<template>
  <v-card class="rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
    <v-sheet class="transactionTable contestTable" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
      <v-data-table class="border-0" :items-per-page="10" :headers="headers" :items="formattedparticipants">
        <template v-slot:item.AmountStatus="{ item }">
          <span :class="getAmountClass(item.amount)">
            ${{ formatAmount(item.amount) }}
          </span>
        </template>

        <template v-slot:item.NameView="{ item }">
          <div class="d-flex align-center">
            {{ item.name || item.email }}
          </div>
        </template>

        <template v-slot:item.depositDate="{ item }">
          {{ formatDate(item.deposit_date) }}
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
import { formatMySQLDate } from '@/_helpers/formateDate';
import moment from 'moment'

export default {
  props: {
    participants: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data() {
    return {
      headers: [
        { text: "Name", value: "NameView", sortable: true },
        { text: "Trading Account", value: "trading_acc", sortable: true },
        { text: "Account Type", value: "acc_type", sortable: true },
        { text: "Deposit Date", value: "depositDate", sortable: true },
        { text: "Amount", value: "AmountStatus", sortable: true },
      ]
    }
  },

  computed: {
    formattedparticipants() {
      return this.participants.map(item => ({
        ...item,
        NameView: item.name || item.email,
        depositDate: item.deposit_date,
        AmountStatus: item.amount,
        trading_acc: item.trading_acc,
        acc_type: item.acc_type || 'Unknown'
      }))
    }
  },

  methods: {
    getAmountClass(amount) {
      return amount > 0 ? 'text--green' : 'text-red'
    },

    formatAmount(amount) {
      return Math.abs(amount).toFixed(2)
    },

    formatDate(date) {
      return formatMySQLDate(date)
    }
  }
}
</script>